import Config from 'react-native-config';
import {DLog} from './HelperMethods';

export const ACCESS_LEVELS = {
  //define the access levels as numbers for quick comparison
  disabled: 0,
  dev: 1,
  staging: 2,
  uat: 3,
  prod: 4,
};

const RNConfig = Config || {};
export const FEATURE_SET = RNConfig.FEATURE_SET || 'prod'; //define the feature set to use in the app

//now we can define individual accesses
export const FEATURE_LEVEL = {
  requestUniqueEmployerId: ACCESS_LEVELS.prod, // defines access for requesting unique employer id
  myContacts: ACCESS_LEVELS.prod, //define access for the manage contacts flow
  shop: ACCESS_LEVELS.prod, //define access for all shop features
  contactSupport: ACCESS_LEVELS.prod, //define access for contact support
  advisingEnabled: ACCESS_LEVELS.prod, //define access for contact support
  darkMode: ACCESS_LEVELS.prod, //in-app appearance setting (#67): migration complete — GA in all builds (My Account → Appearance)
  healthKitSync: ACCESS_LEVELS.dev, //Apple Health blood-glucose write (#65): dev-only until QA'd on a real device
};

//now we can define individual accesses
export const WEB_FEATURE_LEVEL = {
  manualInput: ACCESS_LEVELS.prod, //define access for the manual input blood sugar levels
  chat: ACCESS_LEVELS.dev, //define access for all chat features
  bloodSugarReading: ACCESS_LEVELS.prod, // defines access for blood sugar readings
};

export const hasFeatureEnabled = access => {
  //this function will check if the feature has the access level required
  return !!(
    (
      ACCESS_LEVELS[FEATURE_SET] && //check if the feature set is defined
      access >= ACCESS_LEVELS[FEATURE_SET]
    ) //check if the access level is less than or equal to the feature set
  );
};
